import React from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import "./calendar.css";

/**
 * Reusable Calendar Component
 */
export default function Calendar({
  value,
  onChange,
  mode = "single",
  disabled,
  className = "",
}) {
  const startYear = new Date().getFullYear() - 10;
  const endYear = new Date().getFullYear() + 10;

  return (

    <div className={`calendar-container ${className}`}>
      <DayPicker
        mode={mode}
        key={value}
        selected={value}
        onSelect={onChange}
        disabled={disabled}
        showOutsideDays
        className="custom-calendar"
        captionLayout="dropdown-years" 
        defaultMonth={new Date(2024, 6)}
        startMonth={new Date(startYear, 6)}
        endMonth={new Date(endYear, 9)}
        
      />
    </div>
  );
}

